import { render, staticRenderFns } from "./SingleCollectionItem.vue?vue&type=template&id=0b013218&scoped=true&"
import script from "./SingleCollectionItem.vue?vue&type=script&lang=js&"
export * from "./SingleCollectionItem.vue?vue&type=script&lang=js&"
import style0 from "./SingleCollectionItem.vue?vue&type=style&index=0&id=0b013218&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b013218",
  null
  
)

export default component.exports